import React, {PropTypes} from 'react';
import {Redirect} from 'react-router-dom';
import Select from 'react-select';
import Flags from "./Flags";
import FlagsValue from "./FlagsValue";

class Languages extends React.Component {
  static propTypes = {
    lang: PropTypes.string,
    languages: PropTypes.array,
    match: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      path: "",
    };

    this.handleChange = this.handleChange.bind(this);
  }


  componentDidUpdate() {
    if (this.state.path) {
      this.setState({path: ''});
    }
  }

  handleChange(value) {
    this.setState({path: '/' + value.value + '/' + this.props.match.params.restaurant});
  }

  render() {
    let listLanguages;
    if (this.props.languages) {
      listLanguages = this.props.languages.map((item) => {
        return (
          {
            value: item.code,
            key: 'lang-' + item.code,
            label: item.code
          }
        );
      });
    }

    return (
      <div className="languages">
        {this.state.path ?
          <Redirect to={this.state.path} push/> :
         <Select
          className="topbar-select"
          searchable={false}
          name="select-filter"
          clearable={false}
          arrowRenderer={null}
          value={this.props.lang}
          placeholder={this.props.lang}
          onChange={this.handleChange}
          options={listLanguages}
          optionComponent={Flags}
          valueComponent={FlagsValue}
          />
        }
      </div>
    );
  }
}


export default Languages;



/** WEBPACK FOOTER **
 ** ./src/components/nav/Languages.js
 **/